import React, { SyntheticEvent, useState, useEffect } from 'react';
import { FormikProps, Formik, Field } from 'formik';
import Input from '../../../../components/Input';
import { iRootDispatch, iRootState } from '../../../../store';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import Dropdown from '../../../../components/Dropdown';
import Button from '../../../../components/Button';
import { DATE_INPUT_MASK } from '../../../../services/masks';
import { CustoDropDownItemProps } from '../../../../components/types';
import {
  ButtonsContainer,
  DateContainer,
  EndDate,
  FieldLabel,
  StartDate
} from '../../../../styles';
import {
  AvailableBrokersAndEstatesState,
  FireInsuranceBudgetsListState
} from '../../../../store/types/temp-types';
import AppMaskedInput from '../../../../components/MaskedInput';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import {
  getCanceledBondInsurancesRefunds,
  getCanceledBondInsurancesRefundsReport
} from '../../../../services/canceled-bond-insurance';

import { FilterData } from '../../types';
import { dangerNotification } from '../../../../services/notification';
import { ReportModal } from '../../../../components/ReportModal';

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateList: (state: FireInsuranceBudgetsListState) =>
    dispatch.fireInsuranceBudgetsList.updateFireInsuranceBudgetsList(state),
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

interface ListData {
  data: any;
  setData: (data: any[]) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  page: number;
  setPage: (page: number) => void;
  total: number;
  setTotal: (total: number) => void;
}

type Props = ReturnType<typeof mapDispatch> &
  ReturnType<typeof mapState> &
  FormikProps<FilterData> &
  ListData;

const Filter = (props: Props) => {
  const { isLoading, availableBrokersAndEstates, data, page } = props;

  const dataRefunds = data ? data?.data : [];

  const brokers: CustoDropDownItemProps[] = availableBrokersAndEstates.brokers;
  let defaultBrokerID = '';
  const estates: CustoDropDownItemProps[] = availableBrokersAndEstates.estates;
  let defaultEstateID = '';
  if (estates.length === 1) {
    defaultEstateID = estates[0].value.id;
  }
  if (brokers.length === 1) {
    defaultBrokerID = brokers[0].value.id;
  }

  const initialValues = {
    type: 'name',
    broker_id: defaultBrokerID,
    estate_id: defaultEstateID,
    search: '',
    name: '',
    address: '',
    insurer_id: '',
    start: null,
    end: null
  };

  const [filters, setFilters] = useState<any>(initialValues);
  const [reportModalIsOpen, setReportModalIsOpen] = useState<boolean>(false);
  const [reportState, setReportState] = useState<number | undefined>(undefined);

  const handleExport = async (values: FilterData) => {
    props.setIsLoading(true);
    const status = await getCanceledBondInsurancesRefundsReport(values);
    if (!status) {
      dangerNotification(
        'Ops...',
        'Erro ao solicitar relatório de fiança canceladas e restituídas.'
      );
    } else {
      setReportState(status);
      setReportModalIsOpen(true);
    }
    props.setIsLoading(false);
  };

  const handleReportModalClose = () => {
    setReportModalIsOpen(false);
  };

  useEffect(() => {
    if (data) {
      props.setIsLoading(true);
      getCanceledBondInsurancesRefunds(page, filters)
        .then(dataR => {
          props.setData(dataR);
        })
        .finally(() => {
          props.setIsLoading(false);
        });
    }
  }, [page]);

  return (
    <>
      {reportModalIsOpen && reportState === 200 ? (
        <ReportModal
          isOpen={reportModalIsOpen}
          header="Relatório de Fianças Canceladas Restituídas"
          message={`
                  O relatório será gerado em background e será enviado o link para download via e-mail.
                  Atenção, só será possível gerar um novo relatório após a finalização desse.
                `}
          onClose={handleReportModalClose}
        />
      ) : (
        <ReportModal
          isOpen={reportModalIsOpen}
          header="Relatório de Fianças Canceladas Restituídas"
          message="Já existe um relatório na fila para ser gerado, aguarde a notificação via email."
          onClose={handleReportModalClose}
        />
      )}

      <Formik
        initialValues={initialValues}
        onSubmit={async (values, actions) => {
          props.setIsLoading(true);
          const filter: FilterData = { ...values };
          const filterData = {
            ...filter,
            isRv: true,
            broker_id: filter.broker_id,
            start: filter.start ? filter.start.toISOString().substring(0, 10) : null,
            end: filter.end ? filter.end.toISOString().substring(0, 10) : null,
            name: filter.type === 'name' ? filter.search : '',
            address: filter.type === 'address' ? filter.search : ''
          };
          const dataList = await getCanceledBondInsurancesRefunds(1, filterData);
          setFilters(filterData);
          props.setData(dataList);
          props.setTotal(dataList.count);
          props.setIsLoading(false);
        }}
        onReset={async (values, actions) => {
          props.setIsLoading(true);
          const filter: FilterData = {
            ...values
          };
          const dataList = await getCanceledBondInsurancesRefunds(1, {
            ...initialValues,
            isRv: true,
            broker_id: filter.broker_id
          });
          props.setData(dataList);
          props.setTotal(dataList.count);
          props.setIsLoading(false);
        }}
      >
        {formikProps => {
          return (
            <form onSubmit={formikProps.handleSubmit}>
              <Grid>
                <Grid.Row verticalAlign={'middle'}>
                  <Grid.Column width={2}>
                    <FieldLabel>Pesquisar por</FieldLabel>
                    <div style={{ width: '100%' }}>
                      <Field
                        name="type"
                        component={Dropdown}
                        value={formikProps.values.type}
                        fluid
                        style={{ width: '100%' }}
                        options={[
                          { id: 'name', text: 'Nome do segurado', value: 'name' },
                          { id: 'address', text: 'Endereço', value: 'address' }
                        ]}
                        onChange={(e: SyntheticEvent, data: any) => {
                          formikProps.setFieldValue('type', data.value);
                        }}
                      />
                    </div>
                  </Grid.Column>

                  <Grid.Column width={3}>
                    <FieldLabel>Termo da pesquisa</FieldLabel>
                    <div style={{ width: '100%' }}>
                      <Field
                        name="search"
                        component={Input}
                        fluid
                        style={{ width: '100%' }}
                        value={formikProps.values.search}
                        onChange={(e: SyntheticEvent, data: any) => {
                          formikProps.setFieldValue('search', data.value);
                        }}
                      />
                    </div>
                  </Grid.Column>

                  <Grid.Column width={3}>
                    <FieldLabel>Imobiliária</FieldLabel>
                    <Field
                      name="estate"
                      completeValue={false}
                      onChange={(e: SyntheticEvent, data: any) => {
                        formikProps.setFieldValue('estate_id', data.value.id);
                      }}
                      defaultValue={estates.length === 1 ? estates[0].value : ''}
                      disabled={estates.length === 1 || false}
                      options={availableBrokersAndEstates.estates || []}
                      component={Dropdown}
                      fluid
                    />
                  </Grid.Column>

                  <Grid.Column width={3}>
                    <FieldLabel>Seguradora</FieldLabel>
                    <Field
                      name="insurer"
                      completeValue={false}
                      onChange={(e: SyntheticEvent, data: any) => {
                        formikProps.setFieldValue('insurer_id', data.value.id);
                      }}
                      defaultValue={estates.length === 1 ? estates[0].value : ''}
                      disabled={estates.length === 1 || false}
                      options={availableBrokersAndEstates.bondInsurers || []}
                      component={Dropdown}
                      fluid
                    />
                  </Grid.Column>

                  <Grid.Column width={4}>
                    <FieldLabel>Período</FieldLabel>
                    <DateContainer>
                      <StartDate style={{ marginTop: '-5px' }}>
                        <label style={{ paddingRight: 5 }}>De:</label>
                        <Field
                          name="start"
                          selected={formikProps.values.start}
                          component={CustomDatePicker}
                          onChange={(date: Date) => {
                            formikProps.setFieldValue('start', date);
                          }}
                          customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                          dateFormat={'dd/MM/yyyy'}
                        />
                      </StartDate>
                      <EndDate style={{ marginTop: '-5px' }}>
                        <label style={{ paddingRight: 5 }}>Até:</label>
                        <Field
                          style={{ marginTop: '-5px' }}
                          name="end"
                          selected={formikProps.values.end}
                          component={CustomDatePicker}
                          onChange={(date: Date) => {
                            formikProps.setFieldValue('end', date);
                          }}
                          customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                          dateFormat={'dd/MM/yyyy'}
                        />
                      </EndDate>
                    </DateContainer>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign="middle" reversed="computer tablet">
                  <Grid.Column width={6}>
                    <ButtonsContainer>
                      <Button
                        light
                        fluid
                        disabled={isLoading || dataRefunds.length === 0}
                        type={'button'}
                        text="Exportar"
                        onClick={() => {
                          handleExport(formikProps.values);
                        }}
                      />

                      <Button
                        fluid
                        type={'submit'}
                        disabled={isLoading}
                        text="Pesquisar"
                      />

                      <Button
                        light
                        fluid
                        disabled={isLoading}
                        type={'button'}
                        text="Limpar"
                        onClick={() => {
                          formikProps.setFieldValue('type', 'document');
                          formikProps.setFieldValue('document', '');
                          formikProps.setFieldValue('address', '');
                          formikProps.setFieldValue('broker_id', '');
                          formikProps.setFieldValue('estate', '');
                          formikProps.setFieldValue('insurer', '');
                          formikProps.setFieldValue('start', null);
                          formikProps.setFieldValue('end', null);
                          formikProps.handleReset();
                        }}
                      />
                    </ButtonsContainer>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default connect(mapState, mapDispatch)(Filter);
